import React from 'react';
import Proximamente from '../components/Proximamente';
import Navbar from '../components/Navbar'

const Facturacion = () => {
    return (
        <div>
            <Navbar />
            <Proximamente />
                    </div>
    );
};

export default Facturacion;